import { render, staticRenderFns } from "./RescueOfPersonalized.vue?vue&type=template&id=400ca48b&scoped=true&"
import script from "./RescueOfPersonalized.vue?vue&type=script&lang=js&"
export * from "./RescueOfPersonalized.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfPersonalized.vue?vue&type=style&index=0&id=400ca48b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ca48b",
  null
  
)

export default component.exports